import { create } from "zustand";

/**
 * The compatible car the user picked in the product page's "Select Your Car"
 * section. This is decoupled from the global "Your Car" header (`carStore`) on
 * purpose — it represents the car THIS product is being bought for.
 *
 * It lives in a store (not local component state) so the Add to Cart / Buy Now
 * buttons can read it to (a) gate the action and (b) attach the car to the
 * cart line item / order, while the `CompatibleCarSelector` (desktop + mobile
 * instances) share a single source of truth.
 *
 * `selectedCarId` is the catalog car id (`CompatibleCar.id`, === `cars.id`).
 */
interface ProductCarState {
  selectedCarId: string | null;
  setSelectedCarId: (id: string | null) => void;
  clear: () => void;
}

export const useProductCarStore = create<ProductCarState>((set) => ({
  selectedCarId: null,
  setSelectedCarId: (id) => set({ selectedCarId: id }),
  clear: () => set({ selectedCarId: null }),
}));
